import {DealerItem} from './dealerItem.modal';

export class DealerData{
  pageCount: number;
  rowCount: number;
  dataList: DealerItem[] = [];
}
